module.exports = __webpack_public_path__ + "media/savings_calculator/cal_header_03-169c59f8.png";